import React, { useContext } from 'react'
import { func } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { productDataType } from 'models/propTypes'
import ProductItemDetail from 'components/designSidepanel/ProductItemDetail'
import Icon from 'components/uiElements/Icon'
import StarRatings from 'components/uiElements/StarRatings'
import { ProductData } from 'models/furniture'
import SugarcubeContext from 'apps/SugarcubeContext'

require('./ProductSummary.scss')

interface ProductSummaryProps {
    productData: ProductData;
    trackShowDetails?: () => void;
}

const ProductSummary = ({ productData, trackShowDetails }: ProductSummaryProps) => {
    const { t } = useTranslation()
    const { isKiosk } = useContext(SugarcubeContext)

    const { name, ecommerceUrl, description, price, rating, ratingCount } = productData
    return (
        <div className="ProductSummary">
            <ProductItemDetail name={name} description={description} price={price} isLarge />
            {rating && <StarRatings value={rating} count={ratingCount} />}
            {ecommerceUrl && !isKiosk && (
                <div className="showMoreDetails" onClick={trackShowDetails}>
                    <a className="showMoreDetailsLink" href={ecommerceUrl} target="_blank" rel="noopener noreferrer">
                        <Icon svg code="hyperlink_arrow" />
                        {t('design.show more details')}
                    </a>
                </div>
            )}
        </div>
    )
}
ProductSummary.propTypes = {
    productData: productDataType.isRequired,
    trackShowDetails: func.isRequired,
}

export default ProductSummary
